import { unsafeCoerce } from 'fp-ts/lib/function';
import { UnknownRecord } from '../types/UnknownRecord';

export const withoutUndefinedValues = <T extends object>(object: T): T => {
  const result: UnknownRecord = {};

  Object.entries(object).forEach(([key, value]) => {
    if (value !== undefined) {
      result[key] = value;
    }
  });

  return unsafeCoerce(result);
};
